/* eslint-disable */
import Backdrop from '@material-ui/core/Backdrop';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_SPEED_DIAL_MAIN_BUTTON_CLICKED, UI_SPEED_DIAL_SUB_BUTTON_CLICKED } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import SpeedDialActionWrapper from '../SpeedDialActionWrapper/SpeedDialActionWrapper.component';
import SpeedDialWrapperPropTypes from './SpeedDialWrapper.component.props';
import speedDialWrapperStyles from './SpeedDialWrapper.component.styles';

/**
 * useFabToggles
 * @returns {React.Component} The component
 */
const useFabToggles = () => {
  const [open, setOpen] = useState(false);

  /**
   * handleClick
   * @returns {void} void
   */
  const handleClick = () => setOpen((prevOpen) => !prevOpen);

  /**
   * handleClose
   * @returns {void} void
   */
  const handleClose = () => setOpen(false);

  return [open, handleClick, handleClose];
};

/**
 * SpeedDialWrapper
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const SpeedDialWrapperComponent = ({ actions, options, classes, icon, name, openIcon }) => {
  const [open, handleClick, handleClose] = useFabToggles();

  /**
   * shouldShowAction
   * @param {boolean} shouldShow The show flag
   * @returns {boolean} should show or not
   */
  const shouldShowAction = (shouldShow) => shouldShow === undefined || shouldShow === true;

  /**
   * onActionClick
   * @param {string} key The key
   * @param {func} onClick The onClick handler
   * @returns {void} void
   */
  const onActionClick = (index) => (key, onClick) => () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: key,
        },
      },
      type: UI_SPEED_DIAL_SUB_BUTTON_CLICKED,
    });
    if (onClick) {
      onClick(index);
    }
    handleClose();
  };

  /**
   * onMainSpeedDialClick
   * @returns {void} void
   */
  const onMainSpeedDialClick = () => {
    if(open) return;
    actions.uiTriggered({
      payload: {
        data: {
          name,
        },
      },
      type: UI_SPEED_DIAL_MAIN_BUTTON_CLICKED,
    });
    handleClick();
  };

  return (
    <React.Fragment>
      <ClickAwayListener onClickAway={handleClose}>
        <SpeedDial
          ariaLabel="SpeedDial"
          className={classes.speedDial}
          icon={<SpeedDialIcon icon={icon || <EditIcon />} openIcon={openIcon || <CloseIcon />} />}
          onClick={onMainSpeedDialClick}
          onClose={handleClose}
          open={open}
        >
          {options.map(({ icon: actionIcon, tooltip, onClick, show }, index) => {
            const {
              i18n: { key },
            } = tooltip;
            return (
              shouldShowAction(show) && (
                <SpeedDialActionWrapper icon={actionIcon} key={key} onClick={onActionClick(index)(key, onClick)} open={open} tooltip={tooltip} />
              )
            );
          })}
        </SpeedDial>
      </ClickAwayListener>
      {open && <Backdrop classes={{ root: classes.backDrop }} open={open} />}
    </React.Fragment>
  );
};

SpeedDialWrapperComponent.propTypes = SpeedDialWrapperPropTypes;

const SpeedDialWrapper = compose(
  withStyles(themeCreateInjectableStyles(speedDialWrapperStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(SpeedDialWrapperComponent);

export default SpeedDialWrapper;
